export default "__VITE_ASSET__CwY14PfO__"